import { render } from "./DetalleResidenciaComponent.vue?vue&type=template&id=77785220"
import script from "./DetalleResidenciaComponent.vue?vue&type=script&lang=js"
export * from "./DetalleResidenciaComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__